import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Garde du shell opérateur (sous-arbre `AppLayoutComponent`).
 *
 * Spécificité de l'app operator : le rôle Keycloak `OPERATOR` n'est assigné
 * qu'à **l'approbation admin** (`OperatorService.approve`), pas à la candidature
 * (`apply`). Un utilisateur authentifié **sans** ce rôle est donc soit un
 * candidat potentiel, soit un opérateur `PENDING` en attente d'approbation —
 * dans les deux cas on le route vers `/apply` (formulaire / écran d'attente)
 * plutôt que vers la page `/forbidden` (cul-de-sac 403).
 *
 * `roleGuard('OPERATOR')` reste utilisable pour d'éventuelles routes internes
 * qui doivent vraiment renvoyer un 403 ; ce guard-ci est réservé à l'entrée de
 * l'app.
 */
export const operatorAreaGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/signin'], {
      queryParams: { returnUrl: state.url },
    });
  }
  if (auth.hasRole('OPERATOR')) {
    return true;
  }
  // Authentifié mais pas (encore) opérateur → candidature / écran d'attente.
  return router.createUrlTree(['/apply']);
};
